import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { orthodonticAppliancesHref } from '../utils/localizedRoutes';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-4131" data-mp="2uckbhvmi2cbj">
      <section className="py-16 bg-white" data-id="element-4132" data-mp="2ud2erc7kxqsy">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4133" data-mp="38dd4ud12f1d2">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-4134" data-mp="38cllq1onmw3o">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-4135" data-mp="33c7fmp6m5w8a">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-4136" data-mp="191kgt5w996ch">
            {/* Main Pages */}
            <div data-id="element-4137" data-mp="3jfi2rtm8efnc">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4138" data-mp="3jg1ayim2xpo6">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4139" data-mp="3obp04y0kaito">
                <li data-id="element-4140" data-mp="3sfekfba7ee8w">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4141" data-mp="3se3jrkc21mm0">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-4142" data-mp="ay3vm08pi5dp">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4143" data-mp="axlqsf7zaiu6">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-4144" data-mp="2hqxv632kf3hw">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4145" data-mp="2hrfoaqtxl1ll">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-4146" data-mp="1xo5f86up0sd">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4147" data-mp="1y7c1sr1w2r3">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-4148" data-mp="bvlqjmteyhgr">
                <li data-id="element-4149" data-mp="buk6isuf6kmw">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4150" data-mp="btr6eapyutdq">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-4151" data-mp="gm24d815c53n">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4152" data-mp="gnmy4vfmzk0g">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-4153" data-mp="1991woig9q6xu">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4154" data-mp="199trhr21k0n2">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-4155" data-mp="147w18cv845km">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4156" data-mp="14bjurc0o4rzc">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-4157" data-mp="va2he1enb4ec">
                <li data-id="element-4158" data-mp="vb3ra2jxdkuh">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4159" data-mp="gkeg306gs5qm">
                    All Services
                  </Link>
                </li>
                <li data-id="element-4160" data-mp="7k83dgilb9si">
                  <Link to={`/${lang}/prices#consultations`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4161" data-mp="cijfxz09ryef">
                    Dental Examinations & Consultations
                  </Link>
                </li>
                <li data-id="element-4162" data-mp="3qxelzstrnc7s">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4163" data-mp="3qwwlul3zgdul">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-4164" data-mp="3cx3wou83u5oq">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4165" data-mp="3cwlpj2jwm721">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-4166" data-mp="167p8pk8pnyh7">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4167" data-mp="1665tlwysjth0">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-4168" data-mp="2p1ibci4kt22o">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4169" data-mp="2p10i7ud7n3yz">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-4170" data-mp="2154mmlfg6b0d">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4171" data-mp="215nzvou5kb82">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-4172" data-mp="2f4x5jukqfmxs">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4173" data-mp="2f5fdhogrbplj">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-4174" data-mp="1qfgldc711ys9">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4175" data-mp="1qj4gugw18v9m">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-4176" data-mp="1vgnrz7xforxc">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4177" data-mp="1ve1kt9eggefn">
                    Cosmetic Treatments
                  </Link>
                </li>
                <li data-id="element-4178" data-mp="1hho5a5then3t">
                  <Link to={`/${lang}/services/orthodontics`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4179" data-mp="1hi6bnv9uyhpg">
                    Orthodontics
                  </Link>
                </li>
                <li data-id="element-4180" data-mp="k0pfsv6ylprw">
                  <Link to={orthodonticAppliancesHref(lang)} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4181" data-mp="jz4t1rqvzb4l">
                    Orthodontic Appliances
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-4182" data-mp="2qprcneam274j">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4183" data-mp="2qn5aju6hojtp">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4184" data-mp="3je5b1v5m35gm">
                <li data-id="element-4185" data-mp="3jbsxrvastj9w">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4186" data-mp="35e4cwngqec4u">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-4187" data-mp="1yy23y7r4qxdw">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4188" data-mp="1yybv3ynwval6">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-4189" data-mp="2gn7574odpyq8">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4190" data-mp="2gmnry19obyij">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-4191" data-mp="34d9z7qbuterh">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4192" data-mp="34crue5b4ls7y">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-4193" data-mp="3s349c04sgp81">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4194" data-mp="3s3nppcesj5jy">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-4195" data-mp="8ftwzj5x7dk0">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4196" data-mp="8farx31dcjne">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-4197" data-mp="dgi0337fbkul">
                <li data-id="element-4198" data-mp="hgic6h71vjyh">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4199" data-mp="hha9bwgappqv">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-4200" data-mp="r8o4js17s3e7">
                  <Link to={`/${lang}/blog/dental-implants-cost-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4201" data-mp="w552fdy7tw4h">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-4202" data-mp="1j2brf5i142p2">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4203" data-mp="1j2v7shs16j0z">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-4204" data-mp="1xrrfgdq6du12">
                  <Link to={`/${lang}/blog/dental-treatment-uk-without-insurance`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4205" data-mp="1xs9lu36jxomp">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-4206" data-mp="2gp2djv02mhex">
                  <Link to={`/${lang}/blog/toothache-london-what-to-do`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4207" data-mp="2go9frjj3b28x">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-4208" data-mp="esk1otxfrxh4">
                  <Link to={`/${lang}/blog/veneers-london-everything-you-need-to-know`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4209" data-mp="et3b1m90tdjj">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-4210" data-mp="xqmp54ac5mct">
                  <Link to={`/${lang}/blog/how-to-choose-dentist-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4211" data-mp="xqwdyojn9ngx">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-4212" data-mp="38io5qhe85iil">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4213" data-mp="38j7cd1yfckhb">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-4214" data-mp="33i1j930uqv79">
                <li data-id="element-4215" data-mp="1vkf7yfsjufah">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4216" data-mp="1vjw1pwc9hfca">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-4217" data-mp="1qmvuhi3oe6jl">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4218" data-mp="1bwetfzuydin8">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-4219" data-mp="1gnoiay8oghy2">
                <li data-id="element-4220" data-mp="1gopw3ah2vijh">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4221" data-mp="12w06kw2cbvhm">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-4222" data-mp="szn4b9sqc9b9">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4223" data-mp="xw3z2mufplxb">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-4224" data-mp="abcv1vh8pxyw">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4225" data-mp="o8i0pud1kutm">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-4226" data-mp="t5rtnjzn3om7">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-4227" data-mp="16xy20jwjwrb3">
              <div className="flex items-center gap-2" data-id="element-4228" data-mp="120pst8tdrxlz">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-4229" data-mp="1gx709oyg8s39" />
                <span data-id="element-4230" data-mp="1gvcgidywz60r">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-4231" data-mp="35huos4us4e17">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-4232" data-mp="35f8is9nje6l3">
                <Button size="sm" className="gap-2" data-id="element-4233" data-mp="3aecsr2iac8ch">
                  <Calendar className="w-4 h-4" data-id="element-4234" data-mp="3f6cosjv8ih3s" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-4235" data-mp="3k4nvilq8gbhs">
                <Button variant="whatsapp" size="sm" className="gap-2" data-id="element-4236" data-mp="2mj0bl0ayrln5">
                  <MessageCircle className="w-4 h-4" data-id="element-4237" data-mp="2rhbmzfgwq47h" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-4238" data-mp="2wg4zp5oddr6l">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-4239" data-mp="2wf3ck2u2xe8i">
                  <Phone className="w-4 h-4" data-id="element-4240" data-mp="31gj0c2nn5yul" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}